import { Box, Tooltip, Typography, TypographyProps } from "@mui/material"
import { GuideLineIcon } from 'shared/icons'

import { KojinResult } from "interface/kojin"
import { flatJoin } from "shared/util"

type GuideLineChipsProps = {
	guideLine: KojinResult["guideLine"]
} & TypographyProps
export const GuideLineChips = ({
	guideLine,
	...others
}: GuideLineChipsProps) => guideLine && guideLine.length > 0 ? (
	<Tooltip title={
		<Box>
			{guideLine.map((guide, i) => (
				<Typography
					{...others}
					key={`guide-${i}`}
				>
					{flatJoin(' ', guide.guideLineName, guide.researcherClass)}
				</Typography>
			))}
		</Box>
	}>
		<GuideLineIcon color='secondary' />
	</Tooltip>
) : <></>